import type { CountryIso } from "~/types"

const saudiArabiaEligibleNationalities: CountryIso[] = [
  "ZAF",
  "ALB",
  "DZA",
  "DEU",
  "AND",
  "AUS",
  "AUT",
  "AZE",
  "BHS",
  "BRB",
  "BEL",
  "BRN",
  "BGR",
  "CAN",
  "CHN",
  "CYP",
  "HRV",
  "KOR",
  "DNK",
  "ESP",
  "EST",
  "FIN",
  "FRA",
  "GRC",
  "GRD",
  "GEO",
  "HUN",
  "IRL",
  "ISL",
  "ITA",
  "JPN",
  "KAZ",
  "KGZ",
  "LVA",
  "LIE",
  "LTU",
  "LUX",
  "MDV",
  "MLT",
  "MYS",
  "MAR",
  "MUS",
  "MCO",
  "MNE",
  "NOR",
  "NZL",
  "UZB",
  "PAN",
  "NLD",
  "POL",
  "PRT",
  "CZE",
  "ROU",
  "GBR",
  "RUS",
  "KNA",
  "SMR",
  "SYC",
  "SGP",
  "SVK",
  "SVN",
  "SWE",
  "CHE",
  "TJK",
  "THA",
  "TUR",
  "UKR",
  "USA"
];

export default saudiArabiaEligibleNationalities;